import { createSelector } from '@reduxjs/toolkit';

const myState = (state) => state.soc.customWidget;

export const getCustomWidgets = createSelector(myState, (state) => state.data);
export const getCustomWidget = (uuid) =>
  createSelector(getCustomWidgets, (data) => data.find((x) => x.uuid === uuid));
